
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("7B2m0", function(module, exports) {

$parcel$export(module.exports, "UpflowIframeComponent", () => $e3247c0218342f8b$export$a34263073bbb2ca1);

var $eUqFw = parcelRequire("eUqFw");

var $5GxEP = parcelRequire("5GxEP");

var $aR8n6 = parcelRequire("aR8n6");

var $6U1dF = parcelRequire("6U1dF");

var $9ekFy = parcelRequire("9ekFy");

var $lkWwU = parcelRequire("lkWwU");
const $e3247c0218342f8b$export$a34263073bbb2ca1 = ()=>{
    const [{ renderUpflowModal: renderUpflowModal, targetEdition: targetEdition, product: product, flow: flow, touchpointId: touchpointId, subRoute: subRoute, onClose: onClose, onOpen: onOpen }, { unMountUpflowModal: unMountUpflowModal }] = (0, $lkWwU.useUpflowModal)();
    if (!renderUpflowModal) return null;
    const onModalDismissed = ()=>{
        unMountUpflowModal();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6U1dF.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "upflowIframeComponent",
        packageName: "jiraUpflowIframePlugin"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aR8n6.default), {
        id: "upflowIframeComponent",
        packageName: "jiraUpflowIframePlugin"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9ekFy.UpFlowIFrame), {
        product: product,
        targetEdition: targetEdition,
        flow: flow,
        touchpointId: touchpointId,
        experienceTrackingEnabled: true,
        onClose: onClose || onModalDismissed,
        subRoute: subRoute,
        onOpen: onOpen || undefined
    }))));
};

});
parcelRegister("6U1dF", function(module, exports) {

$parcel$export(module.exports, "NonCritical", () => $7c939f739e44c405$export$20fd89b1bf707b1a);
$parcel$export(module.exports, "default", () => $7c939f739e44c405$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $h3mHU = parcelRequire("h3mHU");
const $7c939f739e44c405$export$83d969795398ec56 = ({ children: children, timerThreshold: timerThreshold })=>{
    const [{ isReady: isReady }] = (0, $h3mHU.useSpaStatePageReady)();
    const [isFirstRun, setFirstRun] = (0, $eUqFw.useState)(true);
    const [hasThresholdTimerExpired, setHasThresholdTimerExpired] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        if (timerThreshold != null) setTimeout(()=>{
            setHasThresholdTimerExpired(true);
        }, timerThreshold);
    }, [
        timerThreshold
    ]);
    if (!isFirstRun || isReady || hasThresholdTimerExpired) {
        isFirstRun && setFirstRun(false);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
    }
    return null;
};
const $7c939f739e44c405$export$5b2f4b62d18632 = ({ id: id = 'non-critical-with-timer', teamName: teamName, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: id,
        teamName: teamName,
        packageName: "jiraPlatformNonCritical",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7c939f739e44c405$export$83d969795398ec56, props));
/**
 * Delays rendering its children until the page is deemed ready, optimizing for a smoother initial load. Suitable for content that is not immediately necessary.
 */ const $7c939f739e44c405$var$NonCriticalComponent = (props)=>{
    const [{ isReady: isReady }] = (0, $h3mHU.useSpaStatePageReady)();
    const [isFirstRun, setFirstRun] = (0, $eUqFw.useState)(true);
    if (!isFirstRun || isReady) {
        isFirstRun && setFirstRun(false);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.children);
    }
    return null;
};
const $7c939f739e44c405$export$20fd89b1bf707b1a = ({ id: id = 'non-critical', teamName: teamName, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: id,
        teamName: teamName,
        packageName: "jiraPlatformNonCritical",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7c939f739e44c405$var$NonCriticalComponent, props));
var $7c939f739e44c405$export$2e2bcd8739ae039 = $7c939f739e44c405$var$NonCriticalComponent;

});

parcelRegister("9ekFy", function(module, exports) {

$parcel$export(module.exports, "UpFlowIFrame", () => $1bd1da7075fc78d1$export$e9eafd8c579e773d);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");


var $3V6nz = parcelRequire("3V6nz");

var $lB1hx = parcelRequire("lB1hx");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1bd1da7075fc78d1$var$UpFlowIFrameLazy = (0, $7rh0R.lazy)(()=>(parcelRequire("cvele")), {
    moduleId: "./src/packages/growth/up-flow/up-flow-iframe/src/main.tsx"
});
const $1bd1da7075fc78d1$export$e9eafd8c579e773d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: (0, $784e146d081cab2a$export$c73007a11ea7e52),
        packageName: (0, $784e146d081cab2a$export$c73007a11ea7e52),
        teamName: "flywheel-tako",
        fallback: (0, $lB1hx.ChunkLoadErrorFlag),
        attributes: (0, $3V6nz.addChunkLoadErrorAnalyticsAttribute)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "flow-iframe-lazy",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1bd1da7075fc78d1$var$UpFlowIFrameLazy, props)));

});
const $784e146d081cab2a$export$c73007a11ea7e52 = 'jiraUpFlowIframe';
const $784e146d081cab2a$export$cb7e587097a78810 = 'upsell-edition';
const $784e146d081cab2a$export$fb320338324d1328 = 'upflowIFrame';
const $784e146d081cab2a$export$782491eab0c2154d = 'INITIATE_SPA_CLOSE';
const $784e146d081cab2a$export$dc3263ec2276f3f3 = 'START_EDITION_POLLING';
const $784e146d081cab2a$export$8a7c66f5574473bd = 'FINISH_EDITION_POLLING';
const $784e146d081cab2a$export$c012ea75b4437aea = 'TRACK_EXPERIENCE_FAIL';
const $784e146d081cab2a$export$1b2e801262ba754 = 'TRACK_EXPERIENCE_SUCCESS';
const $784e146d081cab2a$export$b6cceaecfde9dc91 = 'SPA_READY';

parcelRegister("3V6nz", function(module, exports) {

$parcel$export(module.exports, "applicationEditionToUpFlowEdition", () => $4f19dd0acff36bb5$export$b48ea9d6b982b3e1);
$parcel$export(module.exports, "jiraUpFlowIframeUpgradePlanInteraction", () => $4f19dd0acff36bb5$export$7d4045a899f62dfd);
$parcel$export(module.exports, "addChunkLoadErrorAnalyticsAttribute", () => $4f19dd0acff36bb5$export$94ee0b5fca1e74d2);
$parcel$export(module.exports, "handleError", () => $4f19dd0acff36bb5$export$d3da1ecaf1206c58);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $lEpcX = parcelRequire("lEpcX");

var $guiFP = parcelRequire("guiFP");

var $6WXNs = parcelRequire("6WXNs");



var $fdxQj = parcelRequire("fdxQj");
const $4f19dd0acff36bb5$export$e4e69593f7c9f3b7 = (attributes, error)=>{
    (0, $guiFP.default)({
        meta: {
            // We use the same ID for all errors in the package for easier
            // management in data portal, and use attributes to identify an error instead.
            id: (0, $784e146d081cab2a$export$c73007a11ea7e52),
            packageName: (0, $784e146d081cab2a$export$c73007a11ea7e52),
            teamName: 'flywheel-tako'
        },
        attributes: {
            ...attributes
        },
        error: error
    });
};
const $4f19dd0acff36bb5$export$b48ea9d6b982b3e1 = (applicationEdition)=>{
    if (applicationEdition === (0, $6WXNs.FREE_EDITION)) return 0, $0722a49a19fd82a0$export$e69af2c4378638a2;
    if (applicationEdition === (0, $6WXNs.STANDARD_EDITION)) return 0, $0722a49a19fd82a0$export$7bc7dd5faba7ad6b;
    return 0, $0722a49a19fd82a0$export$3fd0bbb8c68dc4c7;
};
const $4f19dd0acff36bb5$export$7d4045a899f62dfd = (0, $lEpcX.metrics).interaction({
    key: `${(0, $784e146d081cab2a$export$c73007a11ea7e52)}.upgrade.plan`
});
const $4f19dd0acff36bb5$export$94ee0b5fca1e74d2 = (error)=>({
        chunkLoadError: (0, $7rh0R.isLoaderError)(error)
    });
const $4f19dd0acff36bb5$export$d3da1ecaf1206c58 = (subject, onClose, apiError)=>{
    $4f19dd0acff36bb5$export$e4e69593f7c9f3b7({
        subject: subject,
        message: apiError?.message || ''
    }, apiError);
    $4f19dd0acff36bb5$export$7d4045a899f62dfd.cancel();
    onClose();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fdxQj.CommerceApiErrorFlag), null);
};

});
const $0722a49a19fd82a0$export$e69af2c4378638a2 = 'free';
const $0722a49a19fd82a0$export$7bc7dd5faba7ad6b = 'standard';
const $0722a49a19fd82a0$export$3fd0bbb8c68dc4c7 = 'premium';

parcelRegister("fdxQj", function(module, exports) {

$parcel$export(module.exports, "CommerceApiErrorFlag", () => $f9cddb5329b8bde6$export$7ee77c445dd775b4);

var $k8Qyf = parcelRequire("k8Qyf");

var $eo17r = parcelRequire("eo17r");

var $7AaMe = parcelRequire("7AaMe");
const $f9cddb5329b8bde6$export$7ee77c445dd775b4 = ()=>{
    const flagKey = (0, $eo17r.toFlagId)('commerce-api-error');
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    showFlag({
        id: flagKey,
        key: flagKey,
        type: 'error',
        title: (0, $7AaMe.default).title,
        description: (0, $7AaMe.default).description,
        isAutoDismiss: true
    });
    return null;
};

});
parcelRegister("7AaMe", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec87d75cc62a60c4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ec87d75cc62a60c4$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "up-flow-iframe.common.commerce-api-error-flag.title",
        "defaultMessage": "We can't upgrade your plan right now"
    },
    description: {
        "id": "up-flow-iframe.common.commerce-api-error-flag.description",
        "defaultMessage": "Try again, or if this keeps happening try contacting support"
    }
});

});



parcelRegister("lB1hx", function(module, exports) {

$parcel$export(module.exports, "ChunkLoadErrorFlag", () => $fbcf8118023ec96d$export$7a9d9407b3a5f50e);

var $7rh0R = parcelRequire("7rh0R");

var $k8Qyf = parcelRequire("k8Qyf");

var $eo17r = parcelRequire("eo17r");

var $d7NSa = parcelRequire("d7NSa");
const $fbcf8118023ec96d$export$7a9d9407b3a5f50e = ({ error: error })=>{
    const flagKey = (0, $eo17r.toFlagId)('chunk-load-error');
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
    if ((0, $7rh0R.isLoaderError)(error)) showFlag({
        id: flagKey,
        key: flagKey,
        type: 'error',
        title: (0, $d7NSa.default).title,
        description: (0, $d7NSa.default).description,
        isAutoDismiss: true,
        actions: [
            {
                content: (0, $d7NSa.default).refreshPageButton,
                onClick: ()=>{
                    dismissFlag(flagKey);
                    window.location.reload();
                }
            }
        ]
    });
    return null;
};

});
parcelRegister("d7NSa", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf70fc34a5a9ee18$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $cf70fc34a5a9ee18$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "up-flow-iframe.chunk-load-error-flag.title",
        "defaultMessage": "Something went wrong"
    },
    description: {
        "id": "up-flow-iframe.chunk-load-error-flag.description",
        "defaultMessage": "Refresh the page and try again."
    },
    refreshPageButton: {
        "id": "up-flow-iframe.chunk-load-error-flag.refresh-page-button",
        "defaultMessage": "Refresh page"
    }
});

});


parcelRegister("cvele", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('ipZXA')
        ]);
        const value = parcelRequire('9t7R1');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("ipZXA")
    ]).then(()=>parcelRequire('9t7R1'));
}

});


parcelRegister("lkWwU", function(module, exports) {

$parcel$export(module.exports, "useUpflowModal", () => $6c104b62a30eb483$export$7025cc2729b71e44);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
var $dYfll = parcelRequire("dYfll");

var $6WXNs = parcelRequire("6WXNs");

const $6c104b62a30eb483$var$initialState = {
    renderUpflowModal: false,
    product: 'jira-software',
    touchpointId: '',
    flow: 'learn-more',
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onClose: ()=>{},
    targetEdition: (0, $6WXNs.FREE_EDITION)
};
const $6c104b62a30eb483$var$actions = {
    mountUpflowModal: ({ targetEdition: targetEdition, product: product, flow: flow, touchpointId: touchpointId, subRoute: subRoute, onClose: onClose, onOpen: onOpen })=>({ setState: setState })=>{
            setState({
                targetEdition: targetEdition,
                product: product,
                flow: flow,
                touchpointId: touchpointId,
                subRoute: subRoute,
                onClose: onClose,
                onOpen: onOpen,
                renderUpflowModal: true
            });
        },
    unMountUpflowModal: ()=>({ setState: setState })=>{
            setState({
                renderUpflowModal: false
            });
        }
};
const $6c104b62a30eb483$var$Store = (0, $a61MH.createStore)({
    name: (0, $d44c5d835865cf92$export$675a4427bf3750a2),
    initialState: $6c104b62a30eb483$var$initialState,
    actions: $6c104b62a30eb483$var$actions
});
const $6c104b62a30eb483$export$6d73384be122c2dd = (0, $dYfll.createSubscriber)($6c104b62a30eb483$var$Store);
const $6c104b62a30eb483$export$e672be732bd57171 = (0, $heB5U.createContainer)($6c104b62a30eb483$var$Store);
const $6c104b62a30eb483$export$7025cc2729b71e44 = (0, $ggKAj.createHook)($6c104b62a30eb483$var$Store);

});
const $d44c5d835865cf92$export$675a4427bf3750a2 = 'upflow-modal-store';




//# sourceMappingURL=async-upflow-iframe-plugin.13ebdd8a.js.map
